import axiosPublic from "../../api/axiosConfig";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";

const DjResetPassword = () => {
  const [formData, setFormData] = useState({
    token: "",
    password: "",
    confirmPassword: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get("token");

  useEffect(() => {
    if (!token) {
      navigate("/");
      return;
    }

    axiosPublic
      .get(`/auth/forgot-password/${token}/check`)
      .then(() => setLoading(false))
      .catch(() => {
        toast.error("Invalid or expired token");
        navigate("/");
      });
  }, [token, navigate]);

  const validate = (name, value) => {
    let error = "";
    switch (name) {
      case "password":
        error =
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&_\-!"№#]{8,}$/.test(
            value
          )
            ? ""
            : "Password must have 8+ chars, one uppercase, one lowercase, and one number";
        break;
      case "confirmPassword":
        error = value === formData.password ? "" : "Passwords do not match";
        break;
      default:
        break;
    }
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    validate(name, value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (Object.values(errors).some((err) => err)) return;

    setLoading(true);
    formData.token = token;

    try {
      await axiosPublic.post(`/auth/forgot-password/reset`, formData);
      navigate("/login");
    } catch (err) {
      if (err.status === 409) {
        toast.error("Password reset failed. Try again later.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-notificationList p-4">
      <h2 className="text-2xl font-bold text-white mb-6">Reset Password</h2>
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-sm bg-white p-6 rounded-lg shadow-md"
      >
        <input
          type="password"
          name="password"
          placeholder="New password"
          value={formData.password}
          onChange={handleChange}
          required
          className={`w-full mb-3 p-3 border rounded focus:outline-none focus:ring-2 ${
            errors.password ? "border-red-500" : "border-gray-300"
          }`}
        />
        {errors.password && (
          <p className="text-red-500 text-sm mb-2">{errors.password}</p>
        )}

        <input
          type="password"
          name="confirmPassword"
          placeholder="Confirm new password"
          value={formData.confirmPassword}
          onChange={handleChange}
          required
          className={`w-full mb-3 p-3 border rounded focus:outline-none focus:ring-2 ${
            errors.confirmPassword ? "border-red-500" : "border-gray-300"
          }`}
        />
        {errors.confirmPassword && (
          <p className="text-red-500 text-sm mb-2">{errors.confirmPassword}</p>
        )}

        <button
          type="submit"
          disabled={loading}
          className={`w-full p-3 rounded text-white transition ${
            loading
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-blue-600 hover:bg-blue-700"
          }`}
        >
          {loading ? "Resetting..." : "Reset Password"}
        </button>
      </form>
    </div>
  );
};

export default DjResetPassword;
